import React from 'react';
import { Lock } from 'lucide-react';

interface FooterProps {
  onOpenAdmin?: () => void;
}

export const Footer: React.FC<FooterProps> = ({ onOpenAdmin }) => {
  return (
    <footer className="footer">
      <div className="container footer-container">
        <div>
          <p>&copy; {new Date().getFullYear()} Thomas Desrosiers. All rights reserved.</p>
          <p style={{ fontSize: '0.78rem', color: 'var(--text-muted)', marginTop: '0.2rem' }}>
            Built with React, TypeScript, Python / FastAPI &bull; Deployed to GCP Cloud Run
          </p>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '1.5rem', fontSize: '0.85rem' }}>
          <a href="#work" style={{ color: 'var(--text-muted)', textDecoration: 'none' }}>Work</a>
          <a href="#recordings" style={{ color: 'var(--text-muted)', textDecoration: 'none' }}>Recordings</a>
          <a href="#credentials" style={{ color: 'var(--text-muted)', textDecoration: 'none' }}>Background</a>
          <a href="https://classicalremixmusicfestival.org" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--accent-gold)', textDecoration: 'none' }}>Classical Remix</a>
          <button
            onClick={onOpenAdmin || (() => { window.location.hash = '#admin'; })}
            style={{ display: 'inline-flex', alignItems: 'center', gap: '0.3rem', background: 'none', border: 'none', color: 'var(--text-muted)', cursor: 'pointer', fontSize: '0.8rem', padding: 0 }}
            title="Admin Editing Plane"
          >
            <Lock size={12} />
            <span>Admin</span>
          </button>
        </div>
      </div>
    </footer>
  );
};
